import list from './EnterpriseWeChatCode'export default list